import axios from "axios"
import { cca_config } from '../plugins/cca-config'
import store from '@/store'
import guardSession from '@/api/session-guard'

// GET identiques lancés en même temps par plusieurs composants : une seule requête, chaque composant reçoit sa copie
// de la réponse (05/10/2026). Rien n'est gardé : une fois la réponse arrivée, l'appel suivant repart au serveur.
// Jamais partagés : les GET qui écrivent (reset, références de bon, mises à jour), les fichiers et les requêtes annulables.
const GET_NON_PARTAGES = /(^|\/)(reset\/|bon\/reference|update_|fiche-consultation\/edit-content)/
// POST qui ne font que lire (soldes, état d'ouverture de la caisse, coupons à voir), demandés deux fois par la même page.
const POST_LECTURES = /^\/(caisse-operations\/(solde-disponible|solde-compte-depense|compte-coupons)|comptes\/etat-ouverture-caisse)$/
const lecturesEnCours = {}
const copieReponse = reponse => Object.assign({}, reponse, { data: JSON.parse(JSON.stringify(reponse.data)) })

function partager(cle, lancer) {
    if (!lecturesEnCours[cle]) {
        const enCours = lancer()
        lecturesEnCours[cle] = enCours
        const liberer = () => { if (lecturesEnCours[cle] === enCours) delete lecturesEnCours[cle] }
        enCours.then(liberer, liberer)
    }
    return lecturesEnCours[cle].then(copieReponse)
}

function getPartage(get, base, url, config, token) {
    const options = config || {}
    if (GET_NON_PARTAGES.test(String(url)) || (options.responseType && options.responseType !== 'json') || options.cancelToken || options.signal) return get(url, config)
    return partager([base, token, url, JSON.stringify(options.params || {}), JSON.stringify(options.headers || {})].join('|'), () => get(url, config))
}

function postPartage(post, base, url, donnees, config, token) {
    const options = config || {}
    if (!POST_LECTURES.test(String(url)) || (options.responseType && options.responseType !== 'json') || options.cancelToken || options.signal) return post(url, donnees, config)
    return partager(['POST', base, token, url, JSON.stringify(donnees || {}), JSON.stringify(options.params || {}), JSON.stringify(options.headers || {})].join('|'), () => post(url, donnees, config))
}

export default {
    makeRequest(url) {
        const auth_info = store.getters['authInfo']
        let token = ''

        if (auth_info) {
            token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
        }

        const instance = axios.create({
            baseURL: url,
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })

        // Add a response interceptor
        instance.interceptors.response.use(
            response => response, // Return response if successful
            async error => {
                if (error.config && error.config.admin_finance_scoped) return Promise.reject(error)
                if (error.config && error.config.prescripteurs_scoped) return Promise.reject(error)
                if (error.config && error.config.versement_reception_scoped) return Promise.reject(error)
                await guardSession(error, token)
                return Promise.reject(error);
            }
        );
        if (typeof instance.get === 'function') {
            const get = instance.get.bind(instance)
            instance.get = (chemin, config) => getPartage(get, url, chemin, config, token)
        }
        if (typeof instance.post === 'function') {
            const post = instance.post.bind(instance)
            instance.post = (chemin, donnees, config) => postPartage(post, url, chemin, donnees, config, token)
        }

        return instance
    },

    clinique() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_CLINIQUE_API)
    },

    comptabilite() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_CAISSE_API)
    },
    
    stock() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_STOCK_API)
    },

    online() {
        return this.makeRequest('https://google.com')
    }
}
